import React from "react";
import PropTypes from "prop-types";
import DatedCard from "ui/DatedCard";

const PostCard = ({ data, revealDelay }) => {
  const { slug, title, date, publications, publicationCategories } = data;
  const category = publicationCategories
    ? publicationCategories.nodes[0].slug
    : "uncategorized";

  return (
    <DatedCard
      className="post-card"
      path={"/publications/" + category + "/" + slug}
      image={publications.global && publications.global.visuelPublication}
      date={date}
      title={title}
      revealDelay={revealDelay}
    />
  );
};

PostCard.propTypes = {
  revealDelay: PropTypes.number,
};

export default PostCard;
